<template>
  <div class="container">
    <CRow alignHorizontal="end" alignVertical="center">
      <div class="containerIconClose" @click="linkTo(cardContent, 1)">
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>

    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' ' + 'm-2'">
            {{ checkLanguage(data.title) }} :
            {{ checkLanguage(data.description) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody v-if="data">
        <CRow alignHorizontal="center" v-if="data.content">
          <template v-for="item in data.content.item">
            <Vocab
              :key="item.id"
              :lesson="item"
              :cardContent="item"
              :openModal="funcOpenModal"
              :FuncRoute="funcRoute"
              :dataLength="dataLength"
            />
          </template>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import Vocab from '../../../../components/template/Chinese1/Vocab.vue';
import CardPopupImg from '../../../../components/template/Chinese1/CardPopupImg.vue';
import {mapGetters} from 'vuex';
import '../../../../assets/scss/_chineseIcon.scss';
import '../../../../assets/scss/_chineseStyle.scss';

export default {
  name: 'ContentSelect',
  components: {Vocab, CardPopupImg},
  props: {
    cardContent: Object,
    funcOpenModal: Function,
    funcUpdateProgress: Function,
    commitPayloadData: Function,
  },
  data() {
    return {
      data: [],
      content: {},
      hover: false,
      lang: this.$store.getters['language/getLanguage'],
      modal: {
        LKI01: false,
      },
      cardType: 'text',
      dataLength: 0,
    };
  },
  computed: {
    ...mapGetters({
      getLanguage: 'language/getLanguage',
      allCourse: 'template/getTemplateData',
    }),
  },
  watch: {
    allCourse: function (val) {
      this.content = val;
    },
    cardContent: function () {
      this.data = this.cardContent;
      this.dataLength = this.cardContent?.content?.item?.length || 0;
    },
    hover() {},
    getLanguage: function (val) {
      this.lang = val;
    },
  },
  mounted() {},
  created() {
    this.data = this.cardContent;
    this.dataLength = this.cardContent?.content?.item?.length || 0;
  },
  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
    funcRoute(tempId) {
      // const path = tempId.split('-');
      // let body = '/' + str[0] + '/' + str[1];
      // this.$store.commit('necessary/setCodePage', str[1]);
      // this.funcUpdateProgress();
      // this.$router.push(body);
      // const nextPath = `/v4/${path[0]}/${path[1]}`;

      // this.$router.push(nextPath);
      //เรียก commit
      this.commitPayloadData(tempId);
    },
    linkTo(path, text) {
      // if (text == 1) {
      //   let str = path.navigate.close.action.split('-');
      //   let body = '/' + str[0] + '/' + str[1];
      //   this.$store.commit('necessary/setCodePage', str[1]);
      //   this.$router.push(body);
      // }
      //close
      const splitPath = path.navigate.close.action.split('-');
      const closePath = `/v4/${splitPath[0]}/${splitPath[1]}`;

      this.$router.push(closePath);
    },
  },
};
</script>
<style scoped></style>
